export function isCloseEnough(x, y, closeEnough = 1e-10) {
  return Math.abs(x - y) <= closeEnough;
}

export default {
  isCloseEnough
};
